import { SparklesIcon } from "@heroicons/react/24/solid";

import classNames from "../../utils/classNames";
import { IHaulierOption } from "../../utils/hauliers";
import Tooltip from "../shared/Tooltip";
import { aiCellClasses, cellInputClasses } from "./WasteReceiptEditableCell";

const NEW_HAULIER = "__new__";

interface HaulierCellProps {
  value: string | null | undefined;
  options: IHaulierOption[];
  onPick: (haulierAccountId: string | null) => void;
  onCreate: () => void;
  disabled?: boolean;
  /** The linked haulier is the AI's unconfirmed match off the consignment note. */
  aiRead?: boolean;
  width?: string;
}

// Haulier picker shown under the carrier type on third-party rows. Hauliers are accounts flagged
// isHaulier. "No saved haulier" keeps the row on manual entry; the last option opens the account
// form instead of committing.
export function WasteReceiptHaulierCell({ value, options, onPick, onCreate, disabled = false, aiRead = false, width = "w-44" }: HaulierCellProps) {
  return (
    <div className={classNames(width, "relative")} onClick={(e) => e.stopPropagation()}>
      <select
        value={value ?? ""}
        disabled={disabled}
        onChange={(e) => {
          const picked = e.target.value;
          if (picked === NEW_HAULIER) {
            onCreate();
            // Leave the select where it was; the modal's save commits the new haulier.
            e.target.value = value ?? "";
            return;
          }
          onPick(picked === "" ? null : picked);
        }}
        className={classNames(cellInputClasses, aiRead ? classNames(aiCellClasses, "pr-10") : "")}
        aria-label="Haulier"
      >
        <option value="">No saved haulier (type details)</option>
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
        {!disabled && <option value={NEW_HAULIER}>+ Add new haulier…</option>}
      </select>
      {aiRead && (
        <span className="pointer-events-auto absolute inset-y-0 right-6 flex items-center">
          <Tooltip content="Matched by AI from the consignment note - confirm it in the note review">
            <SparklesIcon className="h-3.5 w-3.5 text-violet-500" aria-label="Matched by AI" />
          </Tooltip>
        </span>
      )}
    </div>
  );
}
